import { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../services/authContext';
import { Navigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { ReactSortable } from 'react-sortablejs';
import '../scss/components/nrtOrders.scss';
import CurrentOrders from '../components/modules/nrtOrders/orderLists/CurrentOrders';
import { getNRTOrders } from '../services/nrtService';
import { getUserById } from '../services/userService';

const NrtOrders = () => {
    const { isLoggedIn, userProfile, userRoles } = useContext(AuthContext);
    const [NRTOrders, setNRTOrders] = useState([]);

    const getAllOrders = async () => {
        try {
            const orders = await getNRTOrders();
            if (!orders) {
                setNRTOrders([]);
                return;
            }

            setNRTOrders(orders);
        } catch (error) {
            console.error("Error fetching NRT orders from API:", error);
        }
    };

    useEffect(() => {
        getAllOrders();
    }, []);


    // Redirect if not logged in or missing user profile
    if (!isLoggedIn || !userProfile) {
        return <Navigate to="/" />;
    }

    return (
        <div id="NrtOrders" className="screen">
            <Row>
                <Col xs={12} className="p-0">
                    <Row>
                        <Col xs={12}>
                            <CurrentOrders orders={NRTOrders} />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default NrtOrders;
